import { render, staticRenderFns } from "./itemSubGroupTwo.vue?vue&type=template&id=f49fec7e"
import script from "./itemSubGroupTwo.vue?vue&type=script&lang=js"
export * from "./itemSubGroupTwo.vue?vue&type=script&lang=js"
import style0 from "./itemSubGroupTwo.vue?vue&type=style&index=0&id=f49fec7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports